import { Component, Input } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-model-diff-widget',
    templateUrl: './model-diff-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './model-diff-widget.component.scss'],
    standalone: false
})
export class ModelDiffWidgetComponent extends BaseWidgetComponent {
  @Input() left: string;
  @Input() right: string;

  constructor() {
    super();
  }
}
